export default "__VITE_ASSET__cff687ae__"